import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";

import TeamsReport from "./components/teams";
import LearningsReport from "./components/learnings";
import moment from "moment";
import { Filters } from "./components/filter";
import Actions from "src/components/actionbar";
import { CourseReportContext, CourseReportContextProps } from "./context";
import SelectedFilters from "./components/selectedFilters";

import _ from "lodash";
import cx from "classnames";
import styles from "./reports.module.scss";

import userRoleService from "src/utils/userRoles.service";
import PermissionDenined from "src/components/permissionDenied";

const CoachingReports: React.FC<object> = () => {
  const user = useSelector((state: any) => _.get(state, "users.me.id", null));

  const [activeTab, setActiveTab] = useState(0);
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const [reportContext, setReportContext] = useState<CourseReportContextProps>({
    user: null,
    userGroups: null,
    skills: null,
    startDate: moment().subtract(30, "days").startOf("day").toDate(),
    endDate: moment().endOf("day").toDate(),
  });

  const toggleFilterDialog = () => {
    setShowFilterDialog(!showFilterDialog);
  };

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  const handleConfirm = (state) => {
    setReportContext({
      user: state.user,
      userGroups: state.userGroups,
      skills: state.skills,
      startDate: moment(state.startDate).startOf('day').toDate(),
      endDate: moment(state.endDate).endOf('day').toDate(),
    });
    setShowFilterDialog(false);
  };

  React.useEffect(() => {
    if (!userRoleService.canCreateCourse() && activeTab === 0) {
      setActiveTab(1);
    }
  }, []);

  if (!userRoleService.canAccessCoachingReport()) {
    return <PermissionDenined className={styles.permissionDenied} />;
  }

  const handleRemoveSkill = (skillId: string) => {
    const skills = reportContext.skills?.filter((s) => s.id !== skillId) || [];
    setReportContext((prev) => ({
      ...prev,
      skills,
    }));
  };

  const handleRemoveGroup = (groupId: string) => {
   const userGroups = reportContext.userGroups?.filter((g) => g.id !== groupId) || [];
    setReportContext((prev) => ({
      ...prev,
      userGroups,
    }));
  };

  const filterCount =  _.size(reportContext.skills) + _.size(reportContext.userGroups) + 1 
  const title = filterCount > 0 ?  `Filter ${filterCount}` : "Filters";

  return (
    <CourseReportContext.Provider value={reportContext}>
      <div className={styles.container}>
        <div className={styles.tabsContainer}>
          <div
            className={cx(styles.tabs, {
              [styles.active]: activeTab,
            })}
          >
            {userRoleService.canCreateCourse() && (
              <div
                className={cx(styles.tab, { [styles.active]: activeTab == 0 })}
                onClick={() => handleTabClick(0)}
              >
                teams
              </div>
            )}

            <div
              className={cx(styles.tab, { [styles.active]: activeTab == 1 })}
              onClick={() => handleTabClick(1)}
            >
              learnings
            </div>

            <SelectedFilters
              reportContext={reportContext}
              onRemoveSkill={handleRemoveSkill}
              onRemoveGroup={handleRemoveGroup}
            />
          </div>

          <Actions.Button
            icon={"paperflite-settings"}
            className={styles.filterButton}
            onClick={toggleFilterDialog}
            title={title}
          />
        </div>

        {activeTab === 0 && <TeamsReport />}
        {activeTab === 1 && <LearningsReport />}

        <Filters
          show={showFilterDialog}
          onClose={toggleFilterDialog}
          onConfirm={handleConfirm}
        />
      </div>
    </CourseReportContext.Provider>
  );
};

export { CoachingReports };
